import { useState } from "react"
import Input from '../../../../shared/components/form/input'
import Button from '../../../../shared/components/Button/Button'
import FormLayout from '../../../../shared/components/FormLayout/FormLayout'




function FormEvent({ data, handleOnSubmit }) {

    const [newEvent, setNewEvent] = useState(data || {})

    function handleChange(e) {
        setNewEvent({ ...newEvent, [e.target.name]: e.target.value })
    }
    function submit(){

        handleOnSubmit(newEvent)
    }
    return (
        <FormLayout requiredLegend
            title="Novo Evento"
            actions={
                <Button variant="save" onClick={() => { submit() }}>Salvar</Button>
            }
        >
            <Input
                type="text"
                name="name"
                required text="Evento"
                handleOnChange={handleChange}
                value={newEvent.name || ""}

            />

            <Input
                type="date"
                name="date"
                required text="Mês e Ano"
                handleOnChange={handleChange}
                value={newEvent.date || ""}

            />

            <Input
                type="text"
                name="description"
                required text="Descrição"
                handleOnChange={handleChange}
                value={newEvent.description || ""}

            />
        </FormLayout>
    )


}

export default FormEvent